// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_Gf1","cls2":"TranslationModal-cls2_57r TranslationModal-cls1_Gf1"};